import { Reveal } from "./Reveal";
import { useLang } from "@/i18n";

const NUMS = ["01", "02", "03", "04"];

export default function Process() {
  const { t } = useLang();
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#0E0E0E]/40 py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="mb-3 flex items-center gap-3 text-xs font-bold tracking-[0.25em] text-[#E3AF4F]">
            <span className="h-px w-10 bg-[#E3AF4F]" />
            {t.process.eyebrow}
          </p>
          <h2 className="font-heading text-2xl font-bold leading-snug text-[#F5F2EB] sm:text-3xl lg:text-4xl">
            {t.process.headingA} <span className="text-gold-grad">{t.process.headingB}</span>
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-[#A8A29E]">
            {t.process.paragraph}
          </p>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {t.process.steps.map((s, i) => (
            <Reveal key={NUMS[i]} delay={i * 0.1} className="h-full">
              <article
                data-testid={`process-step-${NUMS[i]}`}
                className="group h-full rounded-3xl border border-[#F5F2EB]/10 bg-[#0E0E0E] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#E3AF4F]/40"
              >
                <span className="font-heading text-3xl font-extrabold text-[#E3AF4F]/40 transition-colors duration-300 group-hover:text-[#E3AF4F]">
                  {NUMS[i]}
                </span>
                <h3 className="mt-5 font-heading text-lg font-bold text-[#F5F2EB]">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#A8A29E]">{s.description}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
